$(function() {
    
    try {
            console.log("custom.js");
            console.log("customerSap:", mainCustomerSap);

            console.log("sessionId: " + localSessionId);
            console.log("remoteSessionId: " + remoteSessionId);

            if(!remoteSessionId && customer && customer != ""){
                console.log("no remote session id");
                const attributes = {
                    attributes: {
                        remoteSessionId: localSessionId
                    }
                };
                updateCartAttribute(attributes, function(data){
                    console.log("updateCartAttribute callback");
                    console.log(data);
                    document.body.classList.add("loading");
                    fetch(`https://sempertex-cross-cart.fly.dev/api/v1/cart/${customer}`, {
                        method: 'GET',
                        headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        },
                    })
                    .then(response => response.json())
                    .then(data => {

                        console.log('Items:', data)
                        if(data != null){
                            location.href = '/pages/redirect';
                        } else {
                            document.body.classList.remove("loading");
                        }
                    });
                });
            }
        } catch (e) {
            console.error("custom.js session init error:", e);
        }

        

        console.log("first_request", first_request);
        
        if(request_host.includes('durpets.com') && request_path !== '/pages/dur' && first_request == ""){
        console.log("durpets.com");

        let attributes = {
            attributes: {
            first_request: "true"
            }
        };

        console.log("redirect");
        location.href = '/pages/dur';

        /*
        updateCartAttribute(attributes, function(data){
            console.log(data);
            location.href = '/pages/home-naval';
        });
        */
        }

        $(document).on('click', '#cartCheckoutWithValidation', function(){
            fetch('/cart.js')
                .then(response => response.json())
                .then(async(data) => {
                    console.log("cart.js");
                    console.log(data);
                    
                    let cart_total = data.total_price / 100;

                    var item_handle = 'b2b-cilindro-de-helio-99-995-para-globos';
                    let contain_handle = data.items.some(item => item.handle === item_handle);
                    let itemsFestipuntos = data.items.filter((item) => {
                    return item.properties.Festipuntos != null;
                    });

                    if(itemsFestipuntos.length > 0){
                    console.log("itemsFestipuntos", itemsFestipuntos);
                    let customerFestipuntos = await getClientDetails(mainCustomerSap);
                    console.log("customerFestipuntos", customerFestipuntos);
                    let availablePoints = customerFestipuntos.data.puntos.Puntos_disponibles;
                    console.log("Puntos_disponibles", availablePoints);
                    let totalPointsUsed = itemsFestipuntos.reduce((total, line) => {
                        return total + (parseInt(line.properties.Festipuntos) * line.quantity);
                    }, 0);
                    console.log("totalPointsUsed", totalPointsUsed);

                    if(totalPointsUsed > availablePoints){
                        Swal.fire({
                            icon: 'error',
                            text: 'No tiene puntos suficientes para esta compra'
                        })
                        return;
                    }

                    }

                    if(cart_total >= min_cart_value || contain_handle || data.items.length == itemsFestipuntos.length){
                        //onsole.log("cart total greater than min cart value");
                        const attributes = {
                            attributes: {
                                min_free_shipping: min_free_shipping
                            }
                        };

                        updateCartAttribute(attributes, function(data){
                            $("#cartCheckout").click();
                        });
                    } else {
                        let formatted_min_cart_value = min_cart_value.toLocaleString('es-CO', {style: 'currency', currency: 'COP'});
                        //remove decimals
                        formatted_min_cart_value = formatted_min_cart_value.substring(0, formatted_min_cart_value.length - 3);
                        Swal.fire({
                            icon: 'error',
                            text: 'No se puede realizar la compra, su pedido deberá ser mínimo de' + formatted_min_cart_value + ' Pesos IVA Incluido'
                        })
                    }
                });
        });

        $(document).on("click", ".reorder-btndsd", function(){
            console.log("click reorder");
            let order = $(this).attr("data-order");
            console.log(order);

            $.ajax({
                url: `/pages/order/_oid=${order}?view=order-detail`,
                dataType: 'html',
                type: 'GET',
                success: function(data){
                    console.log(data);
                },
                error: function(data){console.log('ajax error')},
                complete: function(){}
            });
        });

        $(document).on("click", ".reorder-products-btn", function(){
            $.magnificPopup.close();
            $("body").addClass("loading");
            let order = $(this).attr("data-order");
            console.log(order);
            //iterate all checkboxs that are checked with specific name order
            let items = [];
            $("input[name='reorderChk" + order + "']:checked").each(function(){
                let variant_id = $(this).attr("data-variant-id");
                let quantity = $("#qty_" + variant_id).val();

                items.push({
                    id: variant_id,
                    quantity: quantity
                });
            });

            console.log("items: ");
            console.log(items);

            //add items to cart
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: {
                    items: items
                },
                dataType: 'json',
                success: function(cart) {
                    console.log("success");
                    console.log(cart);

                    // let event = new CustomEvent('item:added',{
                    //     bubbles: true,
                    //     cancelable: true
                    // });
                    // document.dispatchEvent(event);
                    
                    //close magnific popup
                    $("body").removeClass("loading");
                    
                    //redirect to cart page
                    window.location.href = "/cart";
                }
            });
        });

        $(document).on('click', '.remove_all_items', function(){
            $("body").addClass("loading");
            $.ajax({
                type: 'POST',
                url: '/cart/clear.js',
                dataType: 'json',
                success: function(cart) {
                    $("body").removeClass("loading");
                    
                    let event = new CustomEvent('item:added',{
                        bubbles: true,
                        cancelable: true
                    });
                    document.dispatchEvent(event);

                    location.reload();
                }
            });
        });

        $(document).on('click', '.btn-show-variants', function(){
            var variant_row_id = $(this).attr('data-variants-row');
            $("."+variant_row_id).toggle();
        });

        $(document).on('click', '.cart_row_flex_button_toggle', function(){
            let variant_id = $(this).attr('data-id');
            
            $(".cart_row_flex_variants_"+variant_id).slideToggle();

            $(this).children("i").toggleClass('at-plus-l at-minus-l');
            
        });

        //add listener for "item:added" event
        document.addEventListener('item:added', function(e) {
            console.log("Added to cart");
            console.log(e);
            console.log('customer: ' + customer);
            // console.log("cart: ");
            // console.log(CartJS.cart.items);

            if(customer && customer != ""){

                //fetch cart.js
                fetch('/cart.js')
                .then(response => response.json())
                .then(data => {
                    console.log("cart.js");
                    console.log(data);

                    var items = [];

                    for(let i = 0; i < data.items.length; i++){
                        let item = data.items[i];
                        let itemObj = {
                            id: item.id,
                            title: item.title,
                            variant_id: item.variant_id,
                            product_id: item.product_id,
                            feature_image: item.featured_image.url,
                            quantity: item.quantity,
                            price: item.price,
                            handle: item.handle,
                            variant_title: item.variant_title
                        };

                        items.push(itemObj);
                    }

                    let wrapper = {
                        customer: customer,
                        cart: items
                    };
        
                    console.log("wrapper: ");
                    console.log(wrapper);
        
                    //post object to server https://shopifydev.gomonke.com/api/v1/cart
                    $.ajax({
                        type: 'POST',
                        url: 'https://sempertex-cross-cart.fly.dev/api/v1/cart',
                        data: JSON.stringify(wrapper),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function(result) {
                            console.log("success");
                            console.log(result);
                        }
                    });
                    
                });

                // //iterate over CartJS.cart.items
                // let items = [];

                // for(let i = 0; i < CartJS.cart.items.length; i++){
                //     let item = CartJS.cart.items[i];
                //     let itemObj = {
                //         id: item.id,
                //         quantity: item.quantity,
                //         properties: item.properties,
                //         variant_id: item.variant_id
                //     };
                //     items.push(itemObj);
                // };
            }
        });

    
    });

function updateCartAttribute(params, callback){
   //fetch update.js
    fetch('/cart/update.js', {
     method: 'POST',
     headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
     },
     body: JSON.stringify(params)
    }).then(response => response.json())
    .then(data => {
        console.log("update.js");
        console.log(data);
        callback(data);
    });
}

async function getClientDetails(client) {

    let response = await fetch(`https://festipuntosb.sempertex.com/users/`, {
        headers: {
            'Authorization': `Bearer ${client}`
        }
    });
    let data = await response.json();
    
    return data;
}